import { NO_AB_SEGMENT_NAME } from 'root-constants'

export const getAbSegmentName = ({
  optimizeMap,
  optimizeExperimentId,
  optimizeVariantId,
}: {
  optimizeMap: Record<string, Record<string, string>> | null
  optimizeExperimentId: string
  optimizeVariantId: string
}): string =>
  optimizeMap?.[optimizeExperimentId]?.[optimizeVariantId] || NO_AB_SEGMENT_NAME
